module.exports = {"player":{"state":{"error":"Algo salió mal, intente nuevamente más tarde o comuníquese con Soporte.","loading":"CARGANDO"},"controls":{"volumen":{"label-icon":"Volumen","label-up":"Subir Volumen","label-down":"Bajar Volumen"},"presentation-mode":{"label-prev":"Escena anterior","label-next":"Escena siguiente"}},"watermark":{"text":"Creá tu video!"}}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/es/player.json
// module id = 785
// module chunks = 32